import { KuposButton, KuposErrorSuccessModal, KuposModal, SvgHome } from '../common';
import React, { Component } from 'react';

import { AppData } from '../../services';
import KuposCheckbox from '../common/KuposCheckbox';
import KuposInput from '../common/KuposInput';
import KuposRadio from '../common/KuposRadio';
import OperatorPay from './OperatorPay';
import PropTypes from 'prop-types';
import { TermsAndConditions } from '../pages';
import CommonService from '../../services/commonService';

export default class PaymentOptions extends Component {

	componentDidMount() {
		// Set initial values for testing
		sessionStorage.setItem("selectedLanguage", "en");
		// sessionStorage.setItem("centropuertoOperatorData", JSON.stringify({ terms_en: ["link1", "link2"] }));

		// Retrieve language
		const language = sessionStorage.getItem("selectedLanguage");
		console.log("Language is mine:", language);

		// Retrieve centropuerto data
		const centropuertoData = sessionStorage.getItem("centropuertoOperatorData");
		const parsedData = centropuertoData ? JSON.parse(centropuertoData) : null;
		console.log("Parsed Data:", parsedData);

		// Determine TnC Data
		const tncData = language === 'en' ? (parsedData && parsedData.terms_en || []) : "abcd";
		console.log("Terms and Conditions Data:", tncData);
	}
	static propTypes = {
		onPaymentSelect: PropTypes.func,
		selected: PropTypes.number,
		paymentGatewayList: PropTypes.array,
		isLoggedIn: PropTypes.bool,
		walletMoney: PropTypes.number,
		checkWallet: PropTypes.func,
		walletChecked: PropTypes.bool,
		onPay: PropTypes.func,
		bookTicketPending: PropTypes.bool,
		bookingError: PropTypes.string,
		onBookingErrorClick: PropTypes.func,
		onPromoCheckboxChange: PropTypes.func,
		promoCodeChecked: PropTypes.bool,
		promoCode: PropTypes.string,
		onPromoCodeChange: PropTypes.func,
		onPromoCodeBlur: PropTypes.func,
		onApplyPromoCode: PropTypes.func,
		applyPromoCodePending: PropTypes.bool,
		promoCodeError: PropTypes.string,
		tncChecked: PropTypes.bool,
		onTncChange: PropTypes.func,
		t: PropTypes.func,
		history: PropTypes.object,
		totalAmount: PropTypes.number,
		showPromocode: PropTypes.bool,
		showKuposPay: PropTypes.bool,
		showPaypal: PropTypes.bool,
		showBancoEstado: PropTypes.bool,
		corporateDiscountState: PropTypes.object,
		setMotData: PropTypes.func,
		// instantDiscount: PropTypes.objectx,
	};
	constructor(props) {
		super(props);
		this.state = {
			tncError: false,
			cardChecked: false,
			wallet_amount: null,
			payment_mode: null,
			isOneClickEnabled: this.props.isOneClickEnabled,
			validMotOtp: false,
			mot_number: '',
			mot_phone: '',
			mot_otp: '',
		};

		this.isTSService =
			sessionStorage.getItem('isTSService') && sessionStorage.getItem('isTSService') === 'true'
				? true
				: false;
		this.isTSServiceRound =
			sessionStorage.getItem('isTSServiceRound') &&
				sessionStorage.getItem('isTSServiceRound') === 'true'
				? true
				: false;
		
	}

	tncChanged = () => {
		this.setState({ tncError: false });
		this.props.onTncChange();
	};

	onPay = () => {
		console.log("this.props.instantDiscount", this.props.instantDiscount);
		let wallet_amount = this.state.wallet_amount;
		let payment_mode = this.state.payment_mode;
		//  const total =  this.props.totalAmount;
		//  const wallet =   this.props.walletChecked
		// return

		if ( this.props.totalAmount === 0) {
			if (!this.props.tncChecked) {
				this.setState({ tncError: true });
				return;
			} else {
				this.setState({ tncError: false });
			}
			this.props.onPay();
			return;
		}
		if (
			!this.props.selected &&
			!this.state.oneClickChecked1 &&
			!this.state.oneClickChecked2 &&
			!this.props.walletChecked &&
			!this.props.virtualChecked &&
			!this.props.is_mot
		) {
			// if (!this.props.selected && !this.props.cardChecked && this.props.totalAmount > 0) {
			this.setState({ paymentError: true });
			return;
			// } else if (payment_mode == 3 && wallet_amount < this.props.totalAmount) {
		} else if (
			payment_mode == 3 &&
			this.props.walletChecked &&
			this.props.totalAmount > 0
			// (this.props.wallet_amount == 0 || wallet_amount < this.props.totalAmount)
		) {
			console.log(
				'state in onpay if',
				this.props.totalAmount,
				payment_mode,
				wallet_amount,
				this.props.walletChecked,
			);
			this.setState({ insufficentBalanceError: true });
			return;
		} else if (
			this.props.virtualChecked &&
			this.props.totalAmount > 0
			// (this.props.virtualMoneyAmount == 0 || this.props.virtualMoneyAmount < this.props.totalAmount)
		) {
			console.log(
				'state in onpay if',
				this.props.totalAmount,
				payment_mode,
				wallet_amount,
				this.props.walletChecked,
			);
			this.setState({ insufficentBalanceError: true });
			return;
		} else {
			console.log('state in onpay else', this.props.totalAmount, payment_mode, wallet_amount);
			this.setState({ paymentError: false, insufficentBalanceError: false });
		}
		if (!this.props.tncChecked) {
			this.setState({ tncError: true });
			return;
		} else {
			this.setState({ tncError: false });
		}
		this.props.onPay();
	};

	changeCardSelection = (val, key) => {
		// this.props.kuposPayChecked ? this.props.onKuposCheck() : null;
		this.props.cardChoosen(val, key);
		this.props.onPaymentSelect(null);
		this.props.checkWallet(null);
		// onPaymentSelect;

		key == 0
			? this.setState({
				oneClickChecked1: !this.state.oneClickChecked1,
				oneClickChecked2: false,
				// selectedCard: val,
				amountError: false,
				cardChecked: !this.state.cardChecked,
				paymentError: false,
			})
			: this.setState({
				oneClickChecked2: !this.state.oneClickChecked2,
				oneClickChecked1: false,
				// selectedCard: val,
				amountError: false,
				cardChecked: !this.state.cardChecked,
				paymentError: false,
			});
	};

	renderMyCard = (val, key) => {
		// console.log('Value received in render card', val);
		// console.log("Card types in modal are ", this.state.cardTypes);

		return (
			<div
				key={key}
				onClick={() =>
					key == 0 ? this.changeCardSelection(val, key) : this.changeCardSelection(val, key)
				}
			>
				<div className="card-item" key={key}>
					<div className="txn-item">
						<div className="card-image-container">
							{key == 0 ? (
								<KuposRadio
									disabled={true}
									checked={this.state.oneClickChecked1 && this.props.cardChecked}
								/>
							) : (
								<KuposRadio
									disabled={true}
									checked={this.state.oneClickChecked2 && this.props.cardChecked}
								/>
							)}
							{/* <div className="payment-radio-button">
                {key == 0
                  ? this.state.oneClickChecked1 &&
                    this.props.cardChecked && <div className="payment-radio-button-inner" />
                  : this.state.oneClickChecked2 &&
                    this.props.cardChecked && <div className="payment-radio-button-inner" />}
              </div> */}
							{console.log('this.props.cardTypes', this.props.cardTypes)}
							<img
								width={42}
								style={{ width: 42 }}
								src={
									this.props.cardTypes && this.props.cardTypes[val[2]] == 'americanexpress'
										? '/static/images/cards/americanexpress.png'
										: this.props.cardTypes[val[2]] == 'diners'
											? '/static/images/cards/diners.png'
											: this.props.cardTypes[val[2]] == 'magna'
												? '/static/images/cards/magna.png'
												: this.props.cardTypes[val[2]] == 'mastercard'
													? '/static/images/cards/mastercard.png'
													: this.props.cardTypes[val[2]] == 'redcompra'
														? '/static/images/cards/redcompra.png'
														: '/static/images/cards/visa.png'
								}
								alt=""
							/>
						</div>
						<div>
							<span>
								{val[0].replace(/X/gi, '*').substring(8, 12) + ' ' + val[0].substring(12, 16)}
							</span>
						</div>
					</div>
				</div>
			</div>
		);
	};

	sendSMS = () => {
		if (!this.state.mot_number) {
			this.setState({ mot_number_eror: true });
			return;
		}

		if (!this.state.mot_phone) {
			this.setState({ mot_phone_eror: true });
			return;
		}

		let schedule_id =
			this.props &&
			this.props.selectedServiceRouteOnward &&
			this.props.selectedServiceRouteOnward.id &&
			this.props.selectedServiceRouteOnward.id;
		let mot_number = this.state.mot_number || null;
		let mot_phone = this.state.mot_phone || null;

		this.setState({ isLoading: true });
		this.props.actions
			.apiCall({
				url:
					AppData.BASE_URL +
					`api/services/validate_mot_coupon.json?schedule_id=${schedule_id}&mot_coupon=${mot_number}&mobile_no=${mot_phone}`,
				type: 'home',
			})
			.then(
				res => this.onValidateMotCouponResponse(res),
				err => this.onValidateMotCouponResponse(err),
			);
	};

	onValidateMotCouponResponse = res => {
		if (res && res.data && res.data.status == 200 && res.data.data) {
			this.setState({
				resMotMessage: res.data.message,
				showMOTModel: true,
				isLoading: false,
				successMOTModel: true,
				isValidMotcode: true,
				validMotAndNumberError: false,
			});
		} else {
			this.setState({
				resMotMessage: res.data.message,
				// showMOTModel: true,
				validMotAndNumberError: true,
				isLoading: false,
				// successMOTModel: false,
			});
		}
	};

	verifyOTP = () => {
		if (!this.state.mot_otp) {
			this.setState({ mot_otp_eror: true });
			return;
		}
		this.setState({ isLoadingOtp: true });
		this.props.actions
			.apiCall({
				url:
					AppData.BASE_URL +
					`/api/services/validate_sms_code.json?code=${this.state.mot_otp}&mot_code=${this.state.mot_number}`,
				type: 'home',
			})
			.then(
				res => this.onValidateSMSCodeResponse(res),
				err => this.onValidateSMSCodeResponse(err),
			);
	};

	onValidateSMSCodeResponse = res => {
		if (res && res.data && res.data.status === 200) {
			this.setState({
				resMotMessage: res.data.message,
				showMOTModel: true,
				isLoadingOtp: false,
				validMotOtp: true,
				successMOTModel: true,
				paymentError: false,
				validMotOtpError: false,
			});
			this.props.setMotData(res.data.data);
		} else {
			this.setState({
				resMotMessage: res.data.message,
				// showMOTModel: true,
				isLoadingOtp: false,
				validMotOtp: false,
				// successMOTModel: false,
				validMotOtpError: true,
			});
		}
	};

	renderMOTBlock = t => {
		return (
			<div>
				<div className="mb-20">
					<div className="bold-text font13">{t('PASSENGER_DETAILS.MOT_HEADING')}</div>
					<span className="font10">{t('PASSENGER_DETAILS.MOT_SUB_HEADING')}</span>
				</div>
				<div className="is-mot-input">
					<KuposInput
						label={t('PASSENGER_DETAILS.MOT_NUMBER')}
						type="default"
						className="kupos-border"
						onChange={text => {
							this.setState({
								mot_number: text,
								mot_number_eror: false,
								resMotMessage: null,
								validMotAndNumberError: null,
							});
						}}
						onBlur={text => {
							this.setState({ mot_number: text, mot_number_eror: false });
						}}
						error={this.state.mot_number_eror ? true : false}
						errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_NUMBER_ERROR')}
						labelMarginBottom={{ marginBottom: 5 }}
						placeholder={'MOTXXXXXX'}
					/>

					<KuposInput
						label={t('PASSENGER_DETAILS.MOT_PHONE')}
						type="default"
						className="kupos-border"
						onChange={text => {
							this.setState({
								mot_phone: text,
								mot_phone_eror: false,
								resMotMessage: null,
								validMotAndNumberError: null,
							});
						}}
						onBlur={text => { }}
						error={this.state.mot_phone_eror ? true : false}
						errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_PHONE_ERROR')}
						labelMarginBottom={{ marginBottom: 5 }}
						placeholder={'999999999'}
					/>

					<KuposButton
						onClick={this.sendSMS}
						className="font12 mt-12 w-100 mt-3"
						disabled={this.state.isLoading}
						operator={this.props.operator}
					>
						{this.state.isLoading ? (
							<div className="loader-cricle"></div>
						) : (
							<span>{t('PASSENGER_DETAILS.MOT_SEND_CODE')}</span>
						)}
					</KuposButton>
				</div>
				<div className="red-text font9 mt-2 mb-3">
					{this.state.validMotAndNumberError ? this.state.resMotMessage : null}
				</div>

				<div className="is-mot-input-grid mt-12">
					<KuposInput
						label={t('PASSENGER_DETAILS.MOT_OTP')}
						type="default"
						className="kupos-border"
						onChange={text => {
							this.setState({ mot_otp: text, mot_otp_eror: false });
						}}
						onBlur={text => { }}
						error={this.state.mot_otp_eror ? true : false}
						errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_OTP_ERROR')}
						labelMarginBottom={{ marginBottom: 5 }}
					/>

					<KuposInput
						label={t('PASSENGER_DETAILS.MOT_PHONE')}
						type="default"
						className="kupos-border"
						onChange={text => {
							// Check if the input length is greater than 9 for this specific input
							if (text.length > 9) {
								this.setState({ mot_phone_eror2: true });
							} else {
								this.setState({ mot_phone2: text, mot_phone_eror2: false });
							}
						}}
						onBlur={text => { }}
						error={this.state.mot_phone_eror2}
						errorMessage={t('PASSENGER_DETAILS.INSERT_MOT_PHONE_ERROR')}
						labelMarginBottom={{ marginBottom: 5 }}
						placeholder={'999999999'}
					/>

					<KuposButton
						onClick={this.verifyOTP}
						className="font12 mt-12 "
						operator={this.props.operator}
						disabled={!this.state.isValidMotcode || this.state.isLoadingOtp}
					>
						{this.state.isLoadingOtp ? (
							<div className="loader-cricle"></div>
						) : (
							<span>APLICAR CODIGO</span>
						)}
					</KuposButton>
				</div>
				<div className="red-text font9 mt-2 mb-3">
					{this.state.validMotOtpError ? this.state.resMotMessage : null}
				</div>
			</div>
		);

	};

	onSelectOperatorPay = (selected, payment_mode, wallet_amount, virtual) => {
		this.props.checkWallet(selected);

		this.setState({
			paymentError: null,
			tncError: null,
			cardChecked: false,
			oneClickChecked1: false,
			oneClickChecked2: false,
			wallet_amount: wallet_amount,
			payment_mode: payment_mode,
			insufficentBalanceError: null,
		});

		const item = {
			// label: "Kupos Wallet",
			// status: 0,
			code: selected,
			paymentMode: selected,
			payment_mode: payment_mode,
			wallet_amount: wallet_amount,
			virtual,
		};

		this.props.onPaymentSelect(item);
	};

	onSelectCreditos = () => {
		this.setState({ paymentError: null, tncError: null });
		this.props.checkVirtual();
	};



	render() {
		const { t } = this.props;

		const discount = this.props.instantDiscount
      ? CommonService.currency(this.props.instantDiscount.discount_amount)
      : 0;

	  const totalAmount =
	  (this.props.bookingDetailsReturn.totalBookingAmount || 0) +
	  (this.props.bookingDetailsOnward.totalBookingAmount || 0);
	
	const fare_amount = CommonService.currency(totalAmount);
	console.log('fare_amount', fare_amount, discount);

		return (
			<div className="common-payment-options">
				<div
					className="kupos-card payment-block"
					style={this.props.containerStyle ? this.props.containerStyle : {}}
				>
					<div className="payment-block-heading font13">
						{this.props.is_mot ? (
							this.renderMOTBlock(t)
						) : (
							<div>
								{t('PASSENGER_DETAILS.PAYMENT_OPTIONS.NORMAL')}
								<span className="bold font13">{t('PASSENGER_DETAILS.PAYMENT_OPTIONS.BOLD')}</span>
							</div>
						)}
					</div>

					{this.props.operator.operator_name == "centropuerto" && this.props.showPromocode &&
          !this.props.corporateDiscountState &&
          !this.props.instantDiscount ? (
            <div className="payment-block-promo flex-row font11">
              <KuposCheckbox
                label={t('PASSENGER_DETAILS.PROMO_CODE')}
                onChange={this.props.onPromoCheckboxChange}
                checked={this.props.promoCodeChecked}
                operator={this.props.operator}
              />
             { this.props.promoCodeChecked ? (
                <div className="promocode-box flex-row">
                  <KuposInput
                    className="kupos-border"
                    type="text"
                    placeholder={t('PASSENGER_DETAILS.INSERT_PROMO')}
                    value={this.props.promoCode}
                    onChange={this.props.onPromoCodeChange}
                    onBlur={this.props.onPromoCodeBlur}
                    error={this.props.promoCodeError ? true : false}
                    errorMessage={this.props.promoCodeError}
                  />
                  <button
                    className="kupos-button font12"
                    disabled={this.props.applyPromoCodePending ? true : false}
                    onClick={this.props.onApplyPromoCode}
                    style={{
                      backgroundColor:
                        this.props.operator &&
                        this.props.operator.color_codes &&
                        this.props.operator.color_codes.button_color
                          ? this.props.operator.color_codes.button_color
                          : '',
                    }}
                  >
                    {this.props.applyPromoCodePending ? (
                      <div className="loader-cricle"></div>
                    ) : (
                      <span>{t('PASSENGER_DETAILS.APPLY')}</span>
                    )}
                  </button>
                </div>
              ) : null}
            </div>
          ) : null}

					<div className="flex-row payment-methods">
						{/* {console.log('Payment gateways', this.props.paymentGatewayList)} */}
						{!this.props.is_mot &&
							this.props.paymentGatewayList &&
							this.props.paymentGatewayList
								.filter(gateway => {
									if (
										!this.props.myCards &&
										this.props.isLoggedIn &&
										this.props.isOneClickEnabled == 'true'
									) {
										return (
											gateway.label
												.toLowerCase()
												.split(' ')
												.join('-') != 'web-pay-plus'
										);
									} else if (
										this.props.myCards &&
										this.props.myCards.length == 1 &&
										this.props.isLoggedIn &&
										this.props.isOneClickEnabled == 'true'
									) {
										return (
											gateway.label
												.toLowerCase()
												.split(' ')
												.join('-') != 'web-pay-plus'
										);
									} else if (
										this.props.myCards &&
										this.props.myCards.length == 2 &&
										this.props.isLoggedIn &&
										this.props.isOneClickEnabled == 'true'
									) {
										return (
											gateway.label
												.toLowerCase()
												.split(' ')
												.join('-') != 'one-click'
										);
									} else {
										return gateway;
									}
								})
								.map((item, key) =>
									item.status === 0 &&
										((this.props.showPaypal &&
											item.label
												.toLowerCase()
												.split(' ')
												.join('-') === 'paypal') ||
											item.label
												.toLowerCase()
												.split(' ')
												.join('-') === 'web-pay-plus' ||
											// (item.label
											//   .toLowerCase()
											//   .split(' ')
											//   .join('-') === 'kupos-wallet' &&
											//   this.props.isLoggedIn) ||
											// (this.props.showKuposPay &&
											(this.props.isOneClickEnabled &&
												item.label
													.toLowerCase()
													.split(' ')
													.join('-') === 'one-click' &&
												this.props.isLoggedIn) ||
											(this.props.showBancoEstado &&
												item.label
													.toLowerCase()
													.split(' ')
													.join('-') === 'banco-estado')) ? (
										
										<div
										 className={`webpay-payment-method ${fare_amount === discount ? 'disabled' : ''}`}
											key={key}
											onClick={() => {
												this.setState({
													paymentError: null,
													tncError: null,
													cardChecked: false,
													oneClickChecked1: false,
													oneClickChecked2: false,
												});
												item.virtual = false;

												if (sessionStorage.getItem('paymentGatewaySelected') == item.code) {
													sessionStorage.removeItem('paymentGatewaySelected');
												} else {
													sessionStorage.setItem(
														'paymentGatewaySelected',
														JSON.stringify(item.code),
													);
												}
												this.props.onPaymentSelect(item);
												this.props.checkWallet(item);
											}}
										>
											<KuposRadio
												// onChange={() => this.props.onPaymentSelect(item)}
												// checked={item.code == this.props.selected}
												checked={item.code == this.props.selected && !this.props.cardChecked}
												operator={this.props.operator}
											/>

											<div className="payment-checkbox"></div>
											{item.label
												.toLowerCase()
												.split(' ')
												.join('-') == 'web-pay-plus' ? (
												<img src="/static/images/webpay_logo_new.svg" alt="" />
											) : null}
											{item.label
												.toLowerCase()
												.split(' ')
												.join('-') == 'paypal' ? (
												<img src="/static/images/paypal_logo.png" alt="" />
											) : null}
											{item.label
												.toLowerCase()
												.split(' ')
												.join('-') == 'banco-estado' ? (
												<img
													// style={{width:"25vw"}}
													src={'/static/images/banco-estado.png'}
													alt=""
												/>
											) : null}
											{/* {item.label
                        .toLowerCase()
                        .split(' ')
                        .join('-') == 'kupos-wallet' ? (
                        "Kupos Wallet"
                      ) : null} */}
											{item.label
												.toLowerCase()
												.split(' ')
												.join('-') != 'paypal' &&
												item.label
													.toLowerCase()
													.split(' ')
													.join('-') != 'web-pay-plus' &&
												item.label
													.toLowerCase()
													.split(' ')
													.join('-') != 'banco-estado' &&
												item.label
													.toLowerCase()
													.split(' ')
													.join('-') != 'kupos-wallet' ? (
												// <span style={{fontWeight:"bold"}}>{item.label}</span>
												<img
													src={
														this.props.isOneClickEnabled == 'true' &&
															(!this.props.myCards || this.props.myCards.length == 1)
															? '/static/images/webpay_logo_new.svg'
															: '/static/images/one-click.png'
													}
													// style={{width:"25vw"}}
													// src={'/static/images/one-click.png'}
													alt=""
												/>
											) : null}
										</div>
									) : null,
								)}
						{/* {this.props.isLoggedIn && this.props.showKuposPay ? (
              <div className="kupos-payment-moneys kupos-pay-method">
                <div
                  className="kupos-payment-method kupos-pay bold-text font10"
                  onClick={this.props.checkWallet}
                  style={{ marginTop: 10 }}
                >
                  <div className="flex-row kupos-pay-check">
                    <KuposRadio disabled={true} checked={this.props.walletChecked} />{' '}
                    <img
                      onClick={() => {
                        this.setState({ paymentError: null, tncError: null });
                        this.props.checkWallet();
                      }}
                      src="/static/images/kupos_pay_logo.png"
                      alt=""
                    />{' '}
                  </div>
                  <span className="kupos-amount">
                    {' '}
                    {this.props.isLoggedIn
                      ? CommonService.currency(this.props.walletMoney).split(',')[0]
                      : 'CLP $0'}
                  </span>
                </div>
              </div>
            ) : null} */}

						{/* {this.props.isLoggedIn && this.props.showKuposPay ? (
              <div className="kupos-payment-moneys kupos-pay-method">
                <div className="kupos-credit bold-text font10" style={{ marginTop: 10 }}>
                  <KuposCheckbox
                    checked={this.props.virtualChecked}
                    onChange={() => {
                      this.setState({ paymentError: null, tncError: null });
                      this.props.checkVirtual();
                    }}
                    label={'KuposCréditos'}
                    labelStyle={{ fontSize: 12 }}
                    labelBold={true}
                    operator={this.props.operator}
                  />
                  <span className="kupos-amount">
                    {' '}
                    {this.props.isLoggedIn
                      ? CommonService.currency(this.props.virtualMoney).split(',')[0]
                      : 'CLP $0'}
                  </span>
                </div>
              </div>
            ) : null} */}

						{/* {this.props.myCards && this.props.isOneClickEnabled == 'true'
              ? this.props.myCards.map((val, key) => this.renderMyCard(val, key))
              : null} */}

						{/* <div className="kupos-payment-method">    
                   </div> */}
					</div>
					{!this.props.is_mot && (
						<OperatorPay
							{...this.props}
							onSelect={this.onSelectOperatorPay.bind(this)}
							onSelectCreditos={this.onSelectCreditos}
							fare_amount={fare_amount}
							discount={discount}
						/>
					)}
					<div
						className="accept-tnc font9"
						style={this.props.tncContainerStyle ? this.props.tncContainerStyle : {}}
					>
						<KuposCheckbox
							checked={this.props.tncChecked}
							onChange={this.tncChanged}
							operator={this.props.operator}
						/>
						{/* <a onClick={() => this.setState({ showTNCModel: true })}> */}
						<div>
							{this.props.operator && (
								<React.Fragment>
									{this.props.operator.operator_name === 'pullmansanandres' ? (
										<a
											href="/sanandres-terms-and-conditions"
											target="_blank"
											rel="noopener noreferrer"
										>
											{t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART1')}
										</a>
									) : (
										<a onClick={() => this.setState({ showTNCModel: true })}>
											{this.props.operator.operator_name === 'andimar'
												? t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART_ANDIMAR')
												: this.props.operator.operator_name === 'centropuerto'
													? this.props.t('CANCEL_TICKET.I_ACCEPT_TNC1')
													: t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART1')}
										</a>
									)}
								</React.Fragment>
							)}
							{/* <a href="https://c19.cl/" target="_blank" style={{ color: 'blue' }}>
                c19.cl
              </a> */}

							{/* <a onClick={() => this.setState({ showTNCModel: true })}> */}
							{/* <a>{t('PASSENGER_DETAILS.I_ACCEPT_TNC_COVID_PART2')}</a> */}
						</div>
					</div>

					{this.state.tncError ? (
						<div className="tnc-error secondary-text font10 center-text">
							{t('PASSENGER_DETAILS.PLEASE_ACCEPT_TNC')}
						</div>
					) : null}
					{this.state.paymentError ? (
						<div className="tnc-error secondary-text font10 center-text">
							{t('PASSENGER_DETAILS.PLEASE_SELECT_PAYMENT')}
						</div>
					) : null}
					{this.state.insufficentBalanceError ? (
						<div className="tnc-error secondary-text font10 center-text">
							{t('PASSENGER_DETAILS.INSUFFICENT_BALANCE')}
						</div>
					) : null}

					<div className="pay-now-section font13">
						<KuposButton
							onClick={this.onPay}
							// className="font12 mt-12 w-100"
							className="pay-now-button kupos-button"
							operator={this.props.operator}
							disabled={
								this.props.is_mot && !this.state.validMotOtp
									? true
									: this.props.bookTicketPending
										? true
										: false
							}
						>
							{this.props.bookTicketPending || this.props.isLoading ? (
								<div className="loader-cricle"></div>
							) : (
								<span>{t('PASSENGER_DETAILS.PAY')}</span>
							)}
						</KuposButton>

						{/* <button
              onClick={this.onPay}
              className="pay-now-button kupos-button"
              disabled={
                true
                // this.props.is_mot && !this.state.validMotOtp
                // ? true
                // : this.props.bookTicketPending ? true : false
              }
              style={{
                background:
                  this.props.operator &&
                  this.props.operator.color_codes &&
                  this.props.operator.color_codes.button_color
                    ? this.props.operator.color_codes.button_color
                    : '',
                color:
                  this.props.operator && this.props.operator.operator_name === 'combarbala'
                    ? '#000'
                    : '',
              }}
            >
              {this.props.bookTicketPending || this.props.isLoading ? (
                <div className="loader-cricle"></div>
              ) : (
                <span>{t('PASSENGER_DETAILS.PAY')}</span>
              )}
            </button> */}
					</div>
					<KuposErrorSuccessModal
						showModal={this.props.bookingError ? true : false}
						success={false}
						onButtonClick={this.props.onBookingErrorClick}
						bodyText={this.props.bookingError}
					/>
				</div>

				<KuposModal
					ariaLabel="tnc-pnr-modal-outer"
					size={'xl'}
					onHide={() => this.setState({ showTNCModel: false })}
					showModal={this.state.showTNCModel}
				>
					<div className="tnc-pnr-modal">
						<TermsAndConditions />
						<div
							className="close-button pointer"
							onClick={() => this.setState({ showTNCModel: false })}
						>
							<SvgHome name="close" />
						</div>
					</div>
				</KuposModal>

				{/* <KuposModal
					ariaLabel="tnc-pnr-modal-outer"
					size={'xl'}
					onHide={() => this.setState({ showTNCModel: false })}
					showModal={this.state.showTNCModel}
				>
					{tncData.length > 0 ? (
						<ul>
							{tncData.map((term, index) => (
								<li key={index}>{term}</li>
							))}
						</ul>
					) : (
						<TermsAndConditions />// You can customize this message or leave it empty
					)}
				</KuposModal> */}
				<KuposErrorSuccessModal
					showModal={this.state.showMOTModel}
					success={this.state.successMOTModel}
					onButtonClick1={() => this.setState({ showMOTModel: false })}
					bodyText={this.state.resMotMessage}
					showButton1
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/features/common/PaymentOptions.js